import React from 'react';
import styled from 'styled-components';

import CenterBanner from '../../common/banners/CenterBanner';

const Banner = () => (
  <StyledCenterBanner
    subtitle="Drive value across your winery"
    title="Plans &amp; Pricing"
    content="Investments don't need to be complicated. Choose the right plan for your business, deliver the best experience to your customers, and watch your winery grow."
  />
);

const StyledCenterBanner = styled(CenterBanner)`
  padding-bottom: 30px;
`;

export default Banner;
